import { t } from 'i18next';

import { EntityCSVConfig } from '~hooks/useCSVImportExport/configs/types';
import { humanizeCsvHeader } from '~utils/csv/csvProcessor';

/**
 * Call sites pass plural page headings ("Orders", "Material Types"), but the step copy
 * reads "one row per <thing>". Titles that are not plural ("Equipment") are left alone.
 */
function singularizeEntityName(displayName: string) {
  if (displayName.endsWith('ies')) {
    return `${displayName.slice(0, -3)}y`;
  }

  const isAlreadySingular = !displayName.endsWith('s') || displayName.endsWith('ss');

  return isAlreadySingular ? displayName : displayName.slice(0, -1);
}

export default function getCsvImportInstructions<T, TExport>(
  config: EntityCSVConfig<T, TExport>,
  entityDisplayName: string,
) {
  const requiredColumnLabels = config.columns
    .filter((column) => column.required)
    .map((column) => column.label ?? humanizeCsvHeader(column.header));

  return (
    config.importInstructions ??
    t('csv_import_export.steps.fill.description', {
      entity: singularizeEntityName(entityDisplayName).toLowerCase(),
      requiredColumns: requiredColumnLabels.join(', '),
      upsertKey: humanizeCsvHeader('id'),
    })
  );
}
